module.exports = __webpack_public_path__ + "static/media/portrait_allsummer.94e7cf96.png";